<template>
  <div class="home">
      <div class="header">
          <headerShow @changeLanguage="changeLanguageFN"></headerShow>
      </div>
      <div class="homeBody homePattern">
          <div class="patternClass">
              <div class="patternHeader">
                  <div class="patternTitle">{{dataObj.name}}
                    <div class="htmlcommenTime">{{reporterVal}}</div>
                  </div>
                  <div class="patternTime"></div>
              </div>
              <div class="paternContent">
                  <div class="patternleftBg" v-if="dataObj.movie">
                      <!-- <div class="bg">
                        <div style="color: Black">
                            <div>iformats</div>
                        </div>
                    </div> -->            
                    <div v-html="videoHtml"></div>                    
                  </div>
                  <div class="patternleftBg" v-else>
                      <img :src="dataObj.cover" style="width:100%">
                  </div>
                  <div class="patternrightContent">
                      <div class="tagHeader">
                          <Tag class="headerTag" v-for="(item,index) in tagArr" :key="index">{{item}}</Tag>
                      </div>
                      <div class="rePortOut" style="visibility:hidden">
                          <Button class="reportBtn">{{$t("reportVal")}}</Button>
                      </div>
                      <div class="sugestClass" style="visibility:hidden">
                          <div><Icon class="iconFontClass" type="md-thumbs-up" />
                            <span class="numClass">20</span>
                          点赞</div>
                          <div><Icon class="iconFontClass" type="md-heart-outline" />
                          <span class="numClass">20</span>
                          收藏</div>
                          <div><Icon class="iconFontClass" type="md-text" />
                          <span class="numClass">20</span>
                          评论</div>
                      </div>
                      <div class="picListClass" style="visibility: hidden;">
                          <div class="sinaBGclass"></div>
                          <div class="weixinBGclass"></div>
                      </div>
                  </div>
              </div>
              <div class="contentIntroduce">
                <Tabs value="name1">
                    <TabPane :label="$t('detailVal')" name="name1" class="tabpaneClass">
                        <div class="patterndetailNews">
                            <div class="patternLabel">主创人员</div>
                            <div class="patternValue">{{dataObj.staff?dataObj.staff:'无'}}</div>
                        </div>
                        <div class="patterndetailNews">
                            <div class="patternLabel">学校</div>
                            <div class="patternValue">{{dataObj.school?dataObj.school:'无'}}</div>
                        </div>
                        <div class="patterndetailNews">
                            <div class="patternLabel">参赛赛区</div>
                            <div class="patternValue">{{dataObj.area?dataObj.area:'无'}}</div>
                        </div>
                        <div class="patterndetailNews">
                            <div class="patternLabel">指导老师</div>
                            <div class="patternValue">{{dataObj.teacher?dataObj.teacher:'无'}}</div>
                        </div>
                        <div class="patterndetailNews">
                            <div class="patternLabel">参赛赛道</div>
                            <div class="patternValue">{{dataObj.line?dataObj.line:'无'}}</div>
                        </div>
                        <div class="patterndetailNews">
                            <div class="patternLabel">创意阐述</div>
                            <div class="patternValue">{{dataObj.idea?dataObj.idea:'无'}}</div>
                        </div>
                        <div class="patterndetailNews">
                            <div class="patternLabel">获得奖项</div>
                            <div class="patternValue">{{dataObj.awards?dataObj.awards:'无'}}</div>
                        </div>
                        <div class="patterndetailNews">
                            <div class="patternLabel">作者</div>
                            <div class="patternValue">{{dataObj.creater?dataObj.creater:'无'}}</div>
                        </div>
                    </TabPane>
                </Tabs>
              </div>
          </div>
      </div>

      <footerView></footerView>
  </div>
</template>

<script>
import headerShow from '@/components/headerShow.vue'
import footerView from '@/components/footer.vue'
import { matchModeRequest } from '../request/request'
import imageSmallBg from '../assets/2.png'
export default {
  name: 'patternClass',
  components: {
    footerView, headerShow
    // swiper
  },
  data () {
    return {
        videoHtml:'',
        myVideo:null,
      languageVal: 'ch',
      reporterVal: '',
      picLists1: [{ cover: imageSmallBg }, { cover: imageSmallBg }, { cover: imageSmallBg }, { cover: imageSmallBg }, { cover: imageSmallBg }],
      totalNum: 0,
      picLists: [{ cover: imageSmallBg }, { cover: imageSmallBg }, { cover: imageSmallBg }, { cover: imageSmallBg }, { cover: imageSmallBg }],
      conmmitValue: '',
      id: '',
      tagArr: [],
      tagArrEn: [],
      dataObj: {},
      commentList: [],
      page: 1,
      swiperOptionsPics: {
        slidesPerView: 2,
        spaceBetween: 5,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 50
          },
          1920: {
            slidesPerView: 5,
            spaceBetween: 50
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {

  },
  mounted () {
  },
  created () {
    this.$nextTick(() => {
      this.initFN()
      document.scrollingElement.scrollTop = 0
      this.languageVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
    })
  },
  destroyed () {
    this.myVideo.dispose()
    },
  methods: {
    async newsDetailRequestFN (e) {
        var that=this
        var changeVideo = function (vdoSrc) {
            if(that.myVideo){}else{
                that.myVideo = videojs('myVideo', {
                    bigPlayButton: true,
                    textTrackDisplay: false,
                    posterImage: false,
                    errorDisplay: false,
                })
            }
            if (/\.m3u8$/.test(vdoSrc)) { //判断视频源是否是m3u8的格式
                that.myVideo.src({
                    src: vdoSrc,
                    type: 'application/x-mpegURL' //在重新添加视频源的时候需要给新的type的值
                })
            } else {
                that.myVideo.src(vdoSrc)
            }
            that.myVideo.load();
        }
      var res = await matchModeRequest(e)
      if (res.data.code === 0) {
        this.dataObj = res.data.data
        this.videoHtml=`<video id="myVideo" class="video-js vjs-default-skin vjs-big-play-centered" controls preload="auto" data-setup='{}' style='width: 100%;height: auto'>
                        <source id="source" src="${this.dataObj.newMovie}" type="application/x-mpegURL"></source>
                    </video>`
        this.$nextTick(() => {
            this.myVideo = videojs('myVideo', {
                bigPlayButton: true,
                textTrackDisplay: false,
                posterImage: false,
                errorDisplay: false,
            })
          var a = document.querySelector('.commitClass').querySelectorAll('img')
          var b
          for (var i = 0; i < a.length; i++) {
            b = a[i]
            b.parentNode.style.textAlign = 'center'
          }
        })        
      }
    },
    gotoPage (e) {
      window.open(e)
    },
    
    changeLanguageFN (e) {
      this.languageVal = e === 'en' ? 'en' : 'ch'
      localStorage.language = this.languageVal
      this.initFN()
    },
    initFN () {
      this.id = this.$route.query.id
      this.newsDetailRequestFN({ id: this.id })
    }
  }
}
</script>
<style lang="scss">
.patternleftBg .myVideo-dimensions{
//   height: 300px !important;
}
.bottomEndList{
    @include bottomLine
}
.judgeTitle{
    @include startLine;
}
.judgeItem{
    @include startLine;
    align-items: flex-start;
    margin: 5px;
}
.judgeName{
    color: #40A0F0;
    margin-right: 5px;
    @include startLine;
    width: 150px;
}
.patternleftBg img{
    width: 100%;
    height: 100%;
}
.tabpaneClass>div{
    text-align: left;
}
.linkClass{
    cursor: pointer;
}
.linkClass:hover{
    color: #40A0F0;
}
.swiperPicAll .bg_title{
    height: 20vh;
}
video::-webkit-media-controls-enclosure {
    overflow:hidden !important;
}
video::-webkit-media-controls-enclosure {
    overflow:hidden !important;
}
video::-webkit-media-controls-panel {
    width: calc(100% + 30px) !important; /* Adjust as needed */
}
video::-internal-media-controls-download-button {
    display:none !important;
}

.videoClass{

}
.numClass{
    margin: 0 4px;
}
.iconFontClass{
    font-size: 14px;
}
.sugestClass{
    @include betweenLine;
    font-size: 12px;
    width: 18vw;
    margin-top: 2vh;
}
.picListClass{
    margin-top: 5vh;
    @include betweenLine;
    height: 2vw;
    width: 5vw;
}
.sinaBGclass{
    width: 2vw;
    height: 100%;
    @include containbackground;
    background-image: url('../assets/sina.png');
}
.weixinBGclass{
    width: 2vw;
    height: 100%;
    @include containbackground;
    background-image: url('../assets/weixin.png');
}
.commitClass li{
    text-align: left;
}
.commitClass ol{
    list-style-type: decimal;
    margin-left: 20px;
}
.sendCommitClass{
    margin-top: 10px;
    @include bottomLine
}
.bottomCommit{
    width: 100%;
    min-height: 200px;
    margin-top: 30px;
    padding:15px;
    border:1px solid rgba(220,220,220,1);
    box-shadow:0px 3px 6px rgba(0,0,0,0.16);
}
.contentIntroduce{
    margin-top: 15px;
}
.tabpaneClass{
    padding-left: 10px;
}
.patterndetailNews{
    @include startLine
}
.patternLabel{
    @include startLine;
    width: 150px;
    font-size: 14px;
    font-weight: bold;
}
.patternValue{
    // @include startLine;
    min-width: 150px;
    font-size: 14px;
}
.rePortOut{
    @include startLine
}
.reportBtn{
    background:linear-gradient(90deg,rgba(64,160,240,1) 0%,rgba(122,189,245,1) 100%);
    color:white
}
.paternContent{
    @include startLine
}
.tagHeader{
    height: 40%;
}
.tagHeader .ivu-tag{
    border-radius: 11px;
}
.headerTag{
    margin-right: 11px;
}
.tagHeader .ivu-tag-text{
    color: #0072D1;
}
.patternHeader{
    @include betweenLine;
    margin-bottom: 2vh;
    height:40%
}
.homePattern{
    padding-top: 20px;
}
.patternrightContent{
    height: 20.2vw;
    margin-left: 2vw;
}
.patternleftBg{
    width: 33.7vw;
    min-height: 20.2vw;
}
.patternTime{
    font-size:0.7vw;
    color:#92969D
}
.patternClass{
    margin-top: 20px;
    width: 80%;
    margin: 0 auto;
    background: white;
    min-height: 75vh;
    padding: 1vw 5vw;
}
.patternTitle{
    font-size: 1.5vw;
    font-weight:bold
}
.resultPage{
    margin: 15px 0;
    @include bottomLine
}
.resultMark{
    width:15.6vw;
    min-width:160px;
}
// .resultTitle{
//     height: 5vh;
//     min-height: 20px;
//     font-size: 12px;
//     @include centerLine;
//     align-items: flex-start;
// }
.resultItem{
    @include fullbackground;
    margin-bottom: 1vh;
    width:15.6vw;
    height: 8.84vw;
    min-width:160px;
    min-height: 90.6px;
    // background-image: url('../assets/1.png');

}
.resultContent{
    width: 100%;
    min-height: 30vh;
    @include startLine;
    justify-content:space-around;
    flex-wrap: wrap;
    margin-top:3vh;
}

.ivu-tag{
    cursor:pointer
}
.selectOptionAll{
    width: 90%;
    margin:0 auto;
    .selectTitle{
        width: 5vw;
        @include betweenLine;
        min-width: 80px;
        font-size: 16px;
        margin-right: 5vw;
        font-weight: bold;
    }
    .selectOption{
        @include startLine;
        align-items:flex-start;
        flex-wrap: nowrap;
        .optionItems{
            @include startLine;
            flex-wrap: wrap;
        }
    }
}
.detailContent{
    width: 90%;
    margin:0 auto;
}
.home{
    width:100%;
    .header{
      background: #ffffff;
      height: 7vh;
      min-height: 60px;
      padding: 0 0px;
      @include betweenLine;
      color: white;
    }

    .homeBody{
        width: 100%;
        min-height: 75vh;

    }
    .homeBottom{
        width:100%;
        .partnerList{
            font-size: 4vh;
            width: 100%;
            @include centerLine;
            flex-direction: column;
            .partneListTitle{
                margin-top: 3vh;
                margin-bottom:3vh;
                border-bottom:2px solid #2E6DAD
            }
            .partnerListContent{
                @include startLine;
                justify-content: center;
                flex-wrap: wrap;
                width:80%;
                margin: 0 auto;
            }
        }
    }
    .ivu-modal-header{
        background: #2E6DAD
    }
}

</style>
